module.exports = __webpack_public_path__ + "static/media/C20-0321_Bistro_Burger_Desktop_2396x1473.b45e4185.jpg";